import { reducerWithInitialState } from "typescript-fsa-reducers";
import { Entity } from "../documentUpload/types";
import { getEntities, updatePage, updateSearch } from "./actions";

export type InitialEntityListState = null;
export type LoadedEntityListState = Entity[] | any;
export type EntityListState = InitialEntityListState | LoadedEntityListState;

const initialState = null;

const entityListReducer = reducerWithInitialState<EntityListState>(initialState)
  .case(getEntities.async.done, (_, { result }) => {
    return { result, currentPage: _.currentPage };
  })
  .case(updatePage, (state, page) => {
    const currentPage =
      page.selected && page.selected === 0 ? undefined : page.selected;

    return { state, currentPage };
  })
  .case(updateSearch, state => {
    const currentPage = 0;
    return { ...state, currentPage };
  });

export default entityListReducer;



// WEBPACK FOOTER //
// ./src/entityList/reducer.ts